import { useMemo } from 'react';
import { LegType } from '@api/Trinium/types';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import RenderCell from '../../RenderCell';
import { CellProps } from '../../types';

import styles from '../../RenderCell.module.css';

/**
 * Component for rendering the Container column Grid Cells
 */
export default function Container(props: CellProps<DispatchLeg>) {
	const { cntrId, cntrSize, cntrType, wgtLb, legType } = props.row;

	const getWeightDisplay = () => {
		if (wgtLb) {
			return Math.floor(wgtLb).toLocaleString();
		}
		return '';
	};

	const isFCL = useMemo(() => legType && LegType[legType] === LegType.FCL, [legType]);

	return (
		<RenderCell
			editable
			primarySlot={<span className={styles.bold}>{cntrId}</span>}
			secondarySlot={
				(cntrSize || cntrType) && (
					<ContainerSecondaryDisplay
						containerSize={cntrSize}
						containerType={cntrType}
					/>
				)
			}
			tertiarySlot={
				isFCL &&
				wgtLb && (
					<span
						className={styles.bold}
						title={`${wgtLb.toLocaleString()} lbs`}
					>
						{getWeightDisplay()}
					</span>
				)
			}
		/>
	);
}

const ContainerSecondaryDisplay = (props: { containerSize?: number; containerType?: string }) => {
	let displayText: string;

	if (props.containerSize && props.containerType) {
		displayText = `${String(props.containerSize ?? '')} ${props.containerType}`;
	} else {
		// Else one of them is null so don't include the dash
		displayText = `${String(props.containerSize ?? '')}${!props.containerType ? '' : props.containerType}`;
	}

	return (
		<span
			className={styles['secondary-text']}
			title={displayText}
		>
			{displayText}
		</span>
	);
};
